<dx-responsive-box singleColumnScreen="xs sm md">
    <dxi-row [ratio]="1"></dxi-row>
    <dxi-col [ratio]=".5"></dxi-col>
    <dxi-col [ratio]=".5"></dxi-col>
    <dxi-col [ratio]=".5"></dxi-col>
    <dxi-col [ratio]=".3"></dxi-col>

    <dxi-item>
        <dxi-location [row]="0" [col]="0"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> From Award Year</div>
            <div class="dx-field-value">
                <dx-date-box #fromDateBox [(value)]="fromDate" displayFormat="yyyy"
                    [calendarOptions]="{maxZoomLevel: 'decade'}">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="From Award Year is required">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="custom" message="Invalid Date"
                            [validationCallback]="validateFromDate" [reevaluate]="true">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </div>
        </div>
    </dxi-item>
    <dxi-item>
        <dxi-location [row]="0" [col]="1"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> To Award Year</div>
            <div class="dx-field-value">
                <dx-date-box #toDateBox [(value)]="toDate" displayFormat="yyyy"
                    [calendarOptions]="{maxZoomLevel: 'decade'}">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="To Award Year is required">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="custom" message="Invalid Date" [validationCallback]="validateToDate"
                            [reevaluate]="true">
                        </dxi-validation-rule>
                    </dx-validator>

                </dx-date-box>

            </div>
        </div>
    </dxi-item>
    <dxi-item class="marginB10">
        <dxi-location [row]="0" [col]="2"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Regions</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="regions" [(value)]="selectedRegions" [multiline]="false" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Regions is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

    </dxi-item>
    <dxi-item class="marginB10">
        <dxi-location [row]="0" [col]="3"></dxi-location>
        <div class="dx-field">
            <dx-button class="ap-blue-btn" type="default" (onClick)="getReports()" text="View Reports">
            </dx-button>
        </div>

    </dxi-item>
</dx-responsive-box>
<hr />

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="false" [closeOnOutsideClick]="false">
</dx-load-panel>